module.exports = __webpack_public_path__ + "img/footer-logo.023e653c.svg";